import { FC, ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Tune } from '@mui/icons-material'
import { Grid, Dialog } from '@mui/material'

import { CounterButton } from '../../../../components/CounterButton/CounterButton'
import { useLiveEventCommonFilterCounts } from '../../hooks/useLiveEventCommonFilterCounts'
import { FilterApplicability, TLiveEventsCommonFilters, LiveEventsCommonFiltersData } from '../../types/LiveEventsCommonFilters'
import { TrackedGame } from '../../types/TrackedGame'
import { LiveEventsCommonFiltersDialog } from '../LiveEventsCommonFiltersDialog/LiveEventsCommonFiltersDialog'
import LiveEventsEventSearchAutocomplete from '../LiveEventsEventSearchAutocomplete/LiveEventsEventSearchAutocomplete'
import { ActiveCommonFilters } from './ActiveCommonFilters/ActiveCommonFilters'

/**
 * Component  Live Events Tracker view level filters (common filtering for the whole view)
 */
type LiveEventsViewFiltersProps = {
  selectedGames: TrackedGame[]
  commonFilters: TLiveEventsCommonFilters
  commonFiltersData: LiveEventsCommonFiltersData
  filterApplicability?: FilterApplicability
  defaultFilters: TLiveEventsCommonFilters
  eventNameSearchValue: string
  liveEventNames: string[]
  onFiltersChange: (filters: TLiveEventsCommonFilters) => void
  onEventNameSearchValueChange: (value: string) => void
  children?: ReactNode
}

export const LiveEventsViewFilters: FC<LiveEventsViewFiltersProps> = ({
  selectedGames,
  commonFilters,
  commonFiltersData,
  filterApplicability,
  defaultFilters,
  eventNameSearchValue,
  onFiltersChange,
  onEventNameSearchValueChange,
  liveEventNames,
}) => {
  const { t } = useTranslation()
  const hdGameSelected = selectedGames.some((game) => game.game.isAvailableOnPCOrConsole())
  const [commonFiltersDialogOpen, setCommonFiltersDialogOpen] = useState<boolean>(false)
  const { activeCount } = useLiveEventCommonFilterCounts({ filters: commonFilters, data: commonFiltersData, hdGameSelected, filterApplicability })

  return (
    <>
      <Grid container alignItems="center" spacing={2}>
        <Grid item>
          <CounterButton
            label={t('common:filters')}
            count={activeCount}
            variant="contained"
            startIcon={<Tune />}
            onClick={() => setCommonFiltersDialogOpen(true)}
          ></CounterButton>
        </Grid>
        <Grid item flexGrow={1}>
          <LiveEventsEventSearchAutocomplete
            value={eventNameSearchValue}
            onChange={onEventNameSearchValueChange}
            liveEventNames={liveEventNames}
          ></LiveEventsEventSearchAutocomplete>
        </Grid>
      </Grid>
      <Grid container mt={2}>
        <Grid item xs={12}>
          <ActiveCommonFilters filters={commonFilters} filtersData={commonFiltersData} />
        </Grid>
      </Grid>

      <Dialog open={commonFiltersDialogOpen} onClose={() => setCommonFiltersDialogOpen(!commonFiltersDialogOpen)} maxWidth="lg" fullWidth>
        <LiveEventsCommonFiltersDialog
          hdGameSelected={hdGameSelected}
          onClose={() => setCommonFiltersDialogOpen(!commonFiltersDialogOpen)}
          onConfirm={onFiltersChange}
          filters={commonFilters}
          data={commonFiltersData}
          filterApplicability={filterApplicability}
          defaultFilters={defaultFilters}
        />
      </Dialog>
    </>
  )
}
